export default { sha: '5294cb681098a4411e93acc4fd56fa6aef319d10', buildNumber: 'undefined' }
